import './styles.scss'
import React from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import CategoryCard from './CategoryCard'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const CategoriesTypeCard = ({ processType, processes, toggleCategoryModal, toggleDeleteCategoryModal, toggleProcessCalledFromModal, toggleProcessModal, toggleDeleteProcessModal, toggleProcessNotificationModal }) => {
  const { categoriesList } = useSelector(store => store.smartchatHeader)

  return (
    <div className='process-list__categories process-list__categories--type'>
      <div className='process-list__categories-header'>
        <strong className='process-list__categories-title process-list__categories-title--type text-ellipsis'>{I18n.t(`smartchat_categoriesTypeCard_${processType}`)}</strong>
      </div>
      <div className='process-list__categories-body'>
        <CategoryCard
          processType={processType}
          processes={processes.filter(process => process.category === 'none')}
          toggleProcessCalledFromModal={toggleProcessCalledFromModal}
          toggleProcessModal={toggleProcessModal}
          toggleDeleteProcessModal={toggleDeleteProcessModal}
          toggleProcessNotificationModal={toggleProcessNotificationModal}
        />
        {categoriesList.map(category => category.type === processType && (
          <CategoryCard
            key={category._id}
            category={category}
            processType={processType}
            processes={processes.filter(process => process.category === category._id)}
            toggleCategoryModal={toggleCategoryModal}
            toggleDeleteCategoryModal={toggleDeleteCategoryModal}
            toggleProcessCalledFromModal={toggleProcessCalledFromModal}
            toggleProcessModal={toggleProcessModal}
            toggleDeleteProcessModal={toggleDeleteProcessModal}
            toggleProcessNotificationModal={toggleProcessNotificationModal}
          />
        ))}
      </div>
      {processType !== 'conversational' && (
        <Button
          clearPrimary
          icon={
            <figure className='process-list__categories-btn-icon process-list__categories-btn-icon--type'>
              <img src={getStaticImage('/icons/orange-brand/add-circle-icon-primary.svg')} alt='Add category' />
            </figure>
          }
          className='process-list__categories-btn--type'
          value={I18n.t('dashboard_add-category')}
          onClick={() => toggleCategoryModal({ mode: 'add', processType })}
        />
      )}
    </div>
  )
}

export default CategoriesTypeCard
